import { prefetchAll } from './providers/instance-data-providers';
import { prefetchAvailableProducts, } from './providers/products-data-provider';
import prefetchSwitcherBundles from './utils/prefetch-bundles';
export var prefetch = function (props) {
    var cloudId = props.cloudId, enableUserCentricProducts = props.enableUserCentricProducts, product = props.product;
    prefetchSwitcherBundles(product);
    if (cloudId) {
        prefetchAll({ cloudId: cloudId });
    }
    if (enableUserCentricProducts) {
        prefetchAvailableProducts(props.availableProductsDataProvider);
    }
};
//# sourceMappingURL=prefetch.js.map